import { Component, OnInit, Inject, Input, NgModule} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AbstractControl, FormsModule, ValidatorFn, Validators } from '@angular/forms';
import { Organization } from 'src/app/@core/models/infrastructure/Organization.model';
import { Infrastructure } from 'src/app/@core/models/infrastructure/Infrastructure.model';
import { SelectionModel } from '@angular/cdk/collections';
import { FormControl, FormGroup } from '@angular/forms';
import { DarkModeService } from 'src/app/@core/services/dark-mode/dark-mode.service';

@Component({
  selector: 'app-dialog-overview-delete-organization',
  templateUrl: './dialog-overview-delete-organization.component.html',
  styleUrls: ['./dialog-overview-delete-organization.component.scss']
})

export class DialogOverviewDeleteOrganizationComponent{
  infrastructure: Infrastructure;
  organization: Organization;
  organizationForm: FormGroup; 
  
  constructor(
    public dialogRef: MatDialogRef<DialogOverviewDeleteOrganizationComponent>,
    public darkModeService: DarkModeService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
      this.initForm();
    }
    
  initForm(){
    this.organizationForm = new FormGroup({
    orgDelete: new FormControl('', [Validators.required ,this.validationOrganization(this.data)])
  });
 
  }  

  validationOrganization(data): ValidatorFn{
    // La variable valid sirve para que no haga los dos return
    let valid = false;
    return(control: FormControl) : {[key: string]: any} | null  => {
      data.infrastructure.organizations.forEach((organization) => {
        // control.value es el valor del input
        if (organization.name === control.value){
          valid = true;
          return { 'deleteOrganizate' : null };
        }
      });
      if (!valid){
        return { 'deleteOrganizate' : control.value };
      }
      valid = false;
    };
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
